import "@/App.css";
import "lenis/dist/lenis.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Noise from "@/components/Noise";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import TrustedBy from "@/components/TrustedBy";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Results from "@/components/Results";
import Services from "@/components/Services";
import Process from "@/components/Process";
import CaseStudies from "@/components/CaseStudies";
import Insights from "@/components/Insights";
import TipGenerator from "@/components/TipGenerator";
import Playbook from "@/components/Playbook";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";
import ArticlePage from "@/pages/ArticlePage";
import BookPage from "@/pages/BookPage";

const Landing = () => (
  <main className="bg-paper text-ink">
    <Noise />
    <Nav />
    <Hero />
    <TrustedBy />
    <Marquee />
    <Manifesto />
    <Results />
    <Services />
    <Process />
    <CaseStudies />
    <Insights />
    <TipGenerator />
    <Playbook />
    <Booking />
    <Footer />
  </main>
);

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09 }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/insights/:slug" element={<ArticlePage />} />
          <Route path="/book" element={<BookPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </ReactLenis>
  );
}

export default App;
